import React, { createContext, useContext, useState } from 'react';

const ColumnVisibilityContext = createContext();

export const useColumnVisibility = () => {
  const context = useContext(ColumnVisibilityContext);
  if (!context) {
    throw new Error('useColumnVisibility must be used within a ColumnVisibilityProvider');
  }
  return context;
};

export const ColumnVisibilityProvider = ({ children }) => {
  const [isColumnsHidden, setIsColumnsHidden] = useState(true);

  const toggleColumnsVisibility = () => {
    setIsColumnsHidden(prev => !prev);
  };

  const value = {
    isColumnsHidden,
    toggleColumnsVisibility
  };

  return (
    <ColumnVisibilityContext.Provider value={value}>
      {children}
    </ColumnVisibilityContext.Provider>
  );
};
